import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(undefined);

export const ThemeProvider = ({ children }) => {
    // Get theme from localStorage or default to 'light'
    const [theme, setThemeState] = useState(() => {
        const savedTheme = localStorage.getItem('preferredTheme');
        return (savedTheme === 'dark' || savedTheme === 'light') ? savedTheme : 'light';
    });

    const setTheme = (newTheme) => {
        setThemeState(newTheme);
        localStorage.setItem('preferredTheme', newTheme);
        
        // Apply theme to body
        if (newTheme === 'dark') {
            document.body.classList.add('active-dark-mode');
        } else {
            document.body.classList.remove('active-dark-mode');
        }
    };

    useEffect(() => {
        // Get from localStorage on mount
        const savedTheme = localStorage.getItem('preferredTheme');
        if (savedTheme && (savedTheme === 'dark' || savedTheme === 'light')) {
            setThemeState(savedTheme);
            // Apply theme to body
            if (savedTheme === 'dark') {
                document.body.classList.add('active-dark-mode');
            } else {
                document.body.classList.remove('active-dark-mode');
            }
        } else {
            // Set default to light mode if no theme is saved
            setThemeState('light');
            localStorage.setItem('preferredTheme', 'light');
            document.body.classList.remove('active-dark-mode');
        }
    }, []);

    const toggleTheme = () => {
        const newTheme = theme === 'dark' ? 'light' : 'dark';
        setTheme(newTheme);
    };

    return (
        <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};

